export default "__VITE_ASSET__DYa9nFEs__"